import { types, GroupsActionsType, IGroups } from '../types/groups'

export const initialState: IGroups = {
  isLoading: false,
  isLoaded: false,
  list: [],
}

export const groups = (
  state = initialState,
  action: GroupsActionsType
): IGroups => {
  switch (action.type) {
    case types.GET_GROUPS__STARTED:
      return { ...state, isLoading: true }
    case types.GET_GROUPS__SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        list: action.list || [],
      }
    case types.GET_GROUPS__FAILURE:
      return { ...state, isLoading: false, isLoaded: true }
    default:
      return state
  }
}
